import { render } from "./ResultGuide.vue?vue&type=template&id=248fa926"
import script from "./ResultGuide.vue?vue&type=script&lang=js"
export * from "./ResultGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__